import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateUser } from '../state_user';

export const local_user_tutorial_progress_on_sent_to_server = (): PayloadAction<object> => ({
  type: ENUM__redux_action.USER_TUTORIAL_ON_SENT_TO_SERVER,
  payload: {},
});

export function init_local_user_tutorial_progress_on_sent_to_server(state: StateUser, action: PayloadAction<object>) {
  state.tutorial_has_updates_to_send_to_server = false;
}
